import {ResponsiveBar, ResponsiveBarCanvas} from '@nivo/bar';
import {ResponsiveStream} from '@nivo/stream';
import {DateTime} from "luxon";
import {useTheme as nivoUseTheme} from "@nivo/core";
import {Chip, TableTooltip} from "@nivo/tooltip";


const myLabel = ({id}) => {
    // const label = Math.trunc(Number(id.replace(/[^0-9.-]+/g,"")));
    // return label.toLocaleString('en-NZ');
    return id;
};

//TODO need to make sure displayed date/time are in NZ rather than UTC
//TODO add table of the data rows in question
function tooltip({id, value, indexValue}) {
    const datetimeString = indexValue.toFormat('EEE dd-LLL HH:mm');

    return (
        <div
            style={{
                "padding": 5,
                "background": "white",
                "borderRadius": 3
            }}
        >
            <span>{datetimeString}</span>
            <br/>
            <span>{id} {value}MW</span>
        </div>
    )
}


function GenerationOutagesChart({data, keys, colors, useStreamChart}) {

    /*
    <ResponsiveBar
      data={data}
      margin={{ top: 40, right: 20, bottom: 40, left: 40 }}
      indexBy='period_timestamp'
      keys={keys}
      label={myLabel}
      tooltip={tooltip}
      colors={{scheme: 'category10'}}
      animate={false}
    />
     */

    var datetimeTooltipMap = {};
    var gridXValues = [];
    var tickValues = [];
    var tickIndices = [];
    for(let i = 0 ; i < data.length ; ++i) {
        const datetime = data[i].period_timestamp;  // a luxon DateTime object

        if(datetime.hour == 0 && datetime.minute == 0) {
            tickValues.push(datetime);
            tickIndices.push(i);

            if(datetime.weekday == 1)  // Monday
                gridXValues.push(datetime);
        }

        let tooltip = "";
        for(const key_str of keys) {
            if(key_str in data[i]) {
                if(tooltip.length > 0)
                    tooltip = "\n" + tooltip;

                tooltip = key_str + ":\t" + data[i][key_str] + "MW" + tooltip;
            }
        }
        datetimeTooltipMap[datetime] = tooltip;
    }
    //TODO should probably sort these? Or are we assured they're in the correct order already?

    function colour_fn({ id, data, index, value }) {
        const i = keys.indexOf(id);
        if(i >= 0)
            return colors[i % colors.length];

        return "red";
    }

    const tooltip_fn = ({id, value, indexValue}) => (
        <div
            style={{
                "padding": 5,
                "background": "white",
                "borderRadius": 3
            }}
        >
            <span>{indexValue.toFormat('EEE dd-LLL HH:mm')}</span>
            <br/>
            {/*<span>{id} {value}MW</span>*/}
            {/*<br/>*/}
            <pre>
                {
                    (indexValue in datetimeTooltipMap) ? datetimeTooltipMap[indexValue] : ""
                }
            </pre>
        </div>
    );

    if(useStreamChart == null) {
        return (
            <ResponsiveBarCanvas
                data={data}
                keys={keys}
                indexBy='period_timestamp'
                margin={{top: 40, right: 20, bottom: 80, left: 40}}
                enableLabel={false}
                tooltip={tooltip_fn}
                colors={colors}
                animate={false}
                axisBottom={{
                    format: function (datetime) {  // a luxon DateTime object
                        return datetime.toFormat('EEE dd-LLL');
                    },
                    tickRotation: -45,
                    tickValues: tickValues
                }}
                enableGridX={true}
                gridXValues={gridXValues}
            />
        );
    }

    const stackTooltip = ({slice}) => {
        const theme = nivoUseTheme();

        return (
            // see: https://github.com/plouc/nivo/blob/master/packages/tooltip/src/TableTooltip.tsx
            // <TableTooltip
            //     title={data[slice.index].period_timestamp.toFormat('EEE dd-LLL HH:mm')}
            //     rows={slice.stack.map(point => [
            //         <Chip key="chip" color={point.color} style={theme.tooltip.chip}/>,
            //         point.layerLabel,
            //         data[point.index][point.layerLabel]
            //     ])}
            // />
            <div style={{
                background: 'white',
                padding: '9px 12px',
                border: '1px solid #ccc',
                borderRadius: 5
            }}>
                {data[slice.index].period_timestamp.toFormat('EEE dd-LLL HH:mm')}
                <table>
                    <tbody>
                    {slice.stack.map(point =>
                        <tr>
                            <td><Chip key="chip" color={point.color} style={theme.tooltip.chip}/></td>
                            <td>{point.layerLabel}</td>
                            <td>&nbsp;&nbsp;</td>
                            <td align={"right"}>{data[point.index][point.layerLabel].toLocaleString()}</td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
        )
    };

    return (
        <ResponsiveStream
            data={data}
            keys={keys}
            indexBy='period_timestamp'
            // xScale={{ type: 'time', format: "%Y-%m-%d %H:%M", useUTC: false }}
            animate={false}
            colors={colors}
            fillOpacity={0.80}
            margin={{top: 40, right: 110, bottom: 80, left: 40}}
            // enableGridX={true}
            // gridXValues={gridXIndices}
            enableGridY={true}
            curve="stepAfter"
            offsetType="none"
            borderColor={{theme: 'background'}}
            dotSize={8}
            dotBorderWidth={2}
            dotBorderColor={{from: 'color', modifiers: [['darker', 0.7]]}}
            axisBottom={{
                format: function (i) {  // an integer index into the data
                    if(data && i < data.length)
                        return data[i].period_timestamp.toFormat('EEE dd-LLL');
                    return "";
                },
                tickValues: tickIndices,
                tickRotation: -45
            }}
            legends={[
                {
                    anchor: 'bottom-right',
                    direction: 'column',
                    translateX: 100,
                    itemWidth: 80,
                    itemHeight: 20,
                    symbolShape: 'square'
                }
            ]}
            stackTooltip={stackTooltip}
        />
    );
}

export default GenerationOutagesChart;
